function Index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function AboutIndex() {
  return import(
    /* webpackChunkName: "page-about-index" */ '@/pages/about/index.vue'
  )
}
function CampaignFacilitiesIndex() {
  return import(
    /* webpackChunkName: "page-campaign_facilities-index" */ '@/pages/campaign_facilities/index.vue'
  )
}
function CompanyIndex() {
  return import(
    /* webpackChunkName: "page-company-index" */ '@/pages/company/index.vue'
  )
}
function DeregisteredIndex() {
  return import(
    /* webpackChunkName: "page-deregistered-index" */ '@/pages/deregistered/index.vue'
  )
}
function FacilitiesIndex() {
  return import(
    /* webpackChunkName: "page-facilities-index" */ '@/pages/facilities/index.vue'
  )
}
function LawIndex() {
  return import(
    /* webpackChunkName: "page-law-index" */ '@/pages/law/index.vue'
  )
}
function LoginIndex() {
  return import(
    /* webpackChunkName: "page-login-index" */ '@/pages/login/index.vue'
  )
}
function MeIndex() {
  return import(/* webpackChunkName: "page-me-index" */ '@/pages/me/index.vue')
}
function NotificationsIndex() {
  return import(
    /* webpackChunkName: "page-notifications-index" */ '@/pages/notifications/index.vue'
  )
}
function OnlineProgramsIndex() {
  return import(
    /* webpackChunkName: "page-online_programs-index" */ '@/pages/online_programs/index.vue'
  )
}
function PassIndex() {
  return import(
    /* webpackChunkName: "page-pass-index" */ '@/pages/pass/index.vue'
  )
}
function ProgramsIndex() {
  return import(
    /* webpackChunkName: "page-programs-index" */ '@/pages/programs/index.vue'
  )
}
function SearchIndex() {
  return import(
    /* webpackChunkName: "page-search-index" */ '@/pages/search/index.vue'
  )
}
function SignupIndex() {
  return import(
    /* webpackChunkName: "page-signup-index" */ '@/pages/signup/index.vue'
  )
}
function HelpPasswordRecovery() {
  return import(
    /* webpackChunkName: "page-help-password_recovery" */ '@/pages/help/password_recovery.vue'
  )
}
function HelpPasswordReset() {
  return import(
    /* webpackChunkName: "page-help-password_reset" */ '@/pages/help/password_reset.vue'
  )
}
function MeFavoritesIndex() {
  return import(
    /* webpackChunkName: "page-me-favorites-index" */ '@/pages/me/favorites/index.vue'
  )
}
function MePointsIndex() {
  return import(
    /* webpackChunkName: "page-me-points-index" */ '@/pages/me/points/index.vue'
  )
}
function MeProfileIndex() {
  return import(
    /* webpackChunkName: "page-me-profile-index" */ '@/pages/me/profile/index.vue'
  )
}
function MeReservationsIndex() {
  return import(
    /* webpackChunkName: "page-me-reservations-index" */ '@/pages/me/reservations/index.vue'
  )
}
function RankingsUser() {
  return import(
    /* webpackChunkName: "page-rankings-user" */ '@/pages/rankings/user.vue'
  )
}
function MeSubscriptionCancelIndex() {
  return import(
    /* webpackChunkName: "page-me-subscription-cancel-index" */ '@/pages/me/subscription/cancel/index.vue'
  )
}
function MeSubscriptionCancelFormIndex() {
  return import(
    /* webpackChunkName: "page-me-subscription-cancel-form-index" */ '@/pages/me/subscription/cancel/form/index.vue'
  )
}
function ProgramsReservationRequestTimetableIdIndex() {
  return import(
    /* webpackChunkName: "page-programs-reservation_request-timetableId-index" */ '@/pages/programs/reservation_request/_timetableId/index.vue'
  )
}
function FacilitiesFirstSegmentIndex() {
  return import(
    /* webpackChunkName: "page-facilities-firstSegment-index" */ '@/pages/facilities/_firstSegment/index.vue'
  )
}
function NotificationsNotificationIdIndex() {
  return import(
    /* webpackChunkName: "page-notifications-notificationId-index" */ '@/pages/notifications/_notificationId/index.vue'
  )
}
function OnlineProgramsProgramIdIndex() {
  return import(
    /* webpackChunkName: "page-online_programs-programId-index" */ '@/pages/online_programs/_programId/index.vue'
  )
}
function RankingsActivityIdIndex() {
  return import(
    /* webpackChunkName: "page-rankings-activityId-index" */ '@/pages/rankings/_activityId/index.vue'
  )
}
function OnlineFacilitiesFacilityIdIndex() {
  return import(
    /* webpackChunkName: "page-online_facilities-facilityId-index" */ '@/pages/online_facilities/_facilityId/index.vue'
  )
}
function FacilitiesFirstSegmentSecondSegmentIndex() {
  return import(
    /* webpackChunkName: "page-facilities-firstSegment-secondSegment-index" */ '@/pages/facilities/_firstSegment/_secondSegment/index.vue'
  )
}
function FacilitiesFirstSegmentSecondSegmentThirdSegmentIndex() {
  return import(
    /* webpackChunkName: "page-facilities-firstSegment-secondSegment-thirdSegment-index" */ '@/pages/facilities/_firstSegment/_secondSegment/_thirdSegment/index.vue'
  )
}
function FacilitiesFirstSegmentSecondSegmentThirdSegmentReviewsIndex() {
  return import(
    /* webpackChunkName: "page-facilities-firstSegment-secondSegment-thirdSegment-reviews-index" */ '@/pages/facilities/_firstSegment/_secondSegment/_thirdSegment/reviews/index.vue'
  )
}
function FacilitiesFirstSegmentSecondSegmentThirdSegmentProgramsProgramIdIndex() {
  return import(
    /* webpackChunkName: "page-facilities-firstSegment-secondSegment-thirdSegment-programs-programId-index" */ '@/pages/facilities/_firstSegment/_secondSegment/_thirdSegment/programs/_programId/index.vue'
  )
}
function FacilitiesFirstSegmentSecondSegmentThirdSegmentProgramsProgramIdReservationRequestTimetableIdIndex() {
  return import(
    /* webpackChunkName: "page-facilities-firstSegment-secondSegment-thirdSegment-programs-programId-reservation_request-timetableId-index" */ '@/pages/facilities/_firstSegment/_secondSegment/_thirdSegment/programs/_programId/reservation_request/_timetableId/index.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: Index,
    meta: {
      breadcrumbs: []
    }
  },
  {
    name: 'about-index',
    path: 'about',
    component: AboutIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'GYYMについて'
        }
      ]
    }
  },
  {
    name: 'campaign_facilities-index',
    path: 'campaign_facilities',
    component: CampaignFacilitiesIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'キャンペーン実施中の施設'
        }
      ]
    }
  },
  {
    name: 'company-index',
    path: 'company',
    component: CompanyIndex,
    meta: {
      breadcrumbs: [
        {
          name: '会社概要'
        }
      ]
    }
  },
  {
    name: 'deregistered-index',
    path: 'deregistered',
    component: DeregisteredIndex
  },
  {
    name: 'facilities-index',
    path: 'facilities',
    component: FacilitiesIndex,
    meta: {
      breadcrumbs: [
        {
          name: '施設検索'
        }
      ],
      hideFooter: true
    }
  },
  {
    name: 'law-index',
    path: 'law',
    component: LawIndex,
    meta: {
      breadcrumbs: [
        {
          name: '特定商取引法に基づく表記'
        }
      ]
    }
  },
  {
    name: 'login-index',
    path: 'login',
    component: LoginIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'ログイン'
        }
      ]
    }
  },
  {
    name: 'me-index',
    path: 'me',
    component: MeIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'マイページ'
        }
      ]
    }
  },
  {
    name: 'notifications-index',
    path: 'notifications',
    component: NotificationsIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'お知らせ'
        }
      ]
    }
  },
  {
    name: 'online_programs-index',
    path: 'online_programs',
    component: OnlineProgramsIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'オンラインプログラム一覧'
        }
      ]
    }
  },
  {
    name: 'pass-index',
    path: 'pass',
    component: PassIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'GYYM PASS'
        }
      ]
    }
  },
  {
    name: 'programs-index',
    path: 'programs',
    component: ProgramsIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'すべてのプログラム'
        }
      ]
    }
  },
  {
    name: 'search-index',
    path: 'search',
    component: SearchIndex,
    meta: {
      breadcrumbs: [
        {
          name: '検索MENU'
        }
      ]
    }
  },
  {
    name: 'signup-index',
    path: 'signup',
    component: SignupIndex,
    meta: {
      breadcrumbs: [
        {
          name: '新規登録'
        }
      ]
    }
  },
  {
    name: 'help-password_recovery',
    path: 'help/password_recovery',
    component: HelpPasswordRecovery,
    meta: {
      breadcrumbs: [
        {
          name: 'ヘルプ'
        }
      ]
    }
  },
  {
    name: 'help-password_reset',
    path: 'help/password_reset',
    component: HelpPasswordReset,
    meta: {
      breadcrumbs: [
        {
          name: 'ヘルプ'
        }
      ]
    }
  },
  {
    name: 'me-favorites-index',
    path: 'me/favorites',
    component: MeFavoritesIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'マイページ',
          path: '/me'
        },
        {
          name: 'お気に入り'
        }
      ]
    }
  },
  {
    name: 'me-points-index',
    path: 'me/points',
    component: MePointsIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'マイページ',
          path: '/me'
        },
        {
          name: 'ポイント情報'
        }
      ]
    }
  },
  {
    name: 'me-profile-index',
    path: 'me/profile',
    component: MeProfileIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'マイページ',
          path: '/me'
        },
        {
          name: 'プロフィール'
        }
      ]
    }
  },
  {
    name: 'me-reservations-index',
    path: 'me/reservations',
    component: MeReservationsIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'マイページ',
          path: '/me'
        },
        {
          name: '予約一覧'
        }
      ]
    }
  },
  {
    name: 'rankings-user',
    path: 'rankings/user',
    component: RankingsUser,
    meta: {
      breadcrumbs: [
        {
          name: 'ユーザーランキング'
        }
      ]
    }
  },
  {
    name: 'me-subscription-cancel-index',
    path: 'me/subscription/cancel',
    component: MeSubscriptionCancelIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'マイページ',
          path: '/me'
        },
        {
          name: '定期購入',
          path: '/me/subscription'
        },
        {
          name: '定期購入の停止手続き'
        }
      ]
    }
  },
  {
    name: 'me-subscription-cancel-form-index',
    path: 'me/subscription/cancel/form',
    component: MeSubscriptionCancelFormIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'マイページ',
          path: '/me'
        },
        {
          name: '定期購入',
          path: '/me/subscription'
        },
        {
          name: '定期購入の停止手続き'
        }
      ]
    }
  },
  {
    name: 'programs-reservation_request-timetableId-index',
    path: 'programs/reservation_request/:timetableId',
    component: ProgramsReservationRequestTimetableIdIndex,
    meta: {
      breadcrumbs: [
        {
          name: '仮予約内容確認'
        }
      ]
    }
  },
  {
    name: 'facilities-firstSegment-index',
    path: 'facilities/:firstSegment',
    component: FacilitiesFirstSegmentIndex,
    meta: {
      hideFooter: true
    }
  },
  {
    name: 'notifications-notificationId-index',
    path: 'notifications/:notificationId',
    component: NotificationsNotificationIdIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'お知らせ',
          path: '/notifications'
        },
        {
          name: 'お知らせ詳細 - :title'
        }
      ],
      breadcrumbParams: ['title']
    }
  },
  {
    name: 'online_programs-programId-index',
    path: 'online_programs/:programId',
    component: OnlineProgramsProgramIdIndex,
    meta: {
      breadcrumbs: [
        {
          name: 'オンラインプログラム一覧',
          path: '/online_programs'
        },
        {
          name: ':title'
        }
      ],
      breadcrumbParams: ['title']
    }
  },
  {
    name: 'rankings-activityId-index',
    path: 'rankings/:activityId',
    component: RankingsActivityIdIndex,
    meta: {
      breadcrumbs: [
        {
          name: ':activity施設ランキング'
        }
      ],
      breadcrumbParams: ['activity']
    }
  },
  {
    name: 'online_facilities-facilityId-index',
    path: 'online_facilities/:facilityId',
    component: OnlineFacilitiesFacilityIdIndex,
    meta: {
      breadcrumbs: [
        {
          name: '施設検索',
          path: '/facilities'
        },
        {
          name: ':name'
        }
      ],
      breadcrumbParams: ['name']
    }
  },
  {
    name: 'facilities-firstSegment-secondSegment-index',
    path: 'facilities/:firstSegment/:secondSegment',
    component: FacilitiesFirstSegmentSecondSegmentIndex,
    meta: {
      hideFooter: true
    }
  },
  {
    name: 'facilities-firstSegment-secondSegment-thirdSegment-index',
    path: 'facilities/:firstSegment/:secondSegment/:thirdSegment',
    component: FacilitiesFirstSegmentSecondSegmentThirdSegmentIndex,
    meta: {
      hideFooter: true
    }
  },
  {
    name: 'facilities-firstSegment-secondSegment-thirdSegment-reviews-index',
    path: 'facilities/:firstSegment/:secondSegment/:thirdSegment/reviews',
    component: FacilitiesFirstSegmentSecondSegmentThirdSegmentReviewsIndex,
    meta: {
      hideFooter: true
    }
  },
  {
    name:
      'facilities-firstSegment-secondSegment-thirdSegment-programs-programId-index',
    path:
      'facilities/:firstSegment/:secondSegment/:thirdSegment/programs/:programId',
    component: FacilitiesFirstSegmentSecondSegmentThirdSegmentProgramsProgramIdIndex,
    meta: {
      breadcrumbs: [
        {
          name: '施設検索',
          path: '/facilities'
        },
        {
          name: ':facilityName',
          path: ':facilityPath'
        },
        {
          name: ':programName'
        }
      ],
      breadcrumbParams: ['facilityPath', 'facilityName', 'programName']
    }
  },
  {
    name:
      'facilities-firstSegment-secondSegment-thirdSegment-programs-programId-reservation_request-timetableId-index',
    path:
      'facilities/:firstSegment/:secondSegment/:thirdSegment/programs/:programId/reservation_request/:timetableId',
    component: FacilitiesFirstSegmentSecondSegmentThirdSegmentProgramsProgramIdReservationRequestTimetableIdIndex,
    meta: {
      breadcrumbs: [
        {
          name: '仮予約内容確認'
        }
      ]
    }
  }
]
